import { render, staticRenderFns } from "./MoonLandingPageFooter.vue?vue&type=template&id=7fdb8f75&scoped=true"
import script from "./MoonLandingPageFooter.vue?vue&type=script&lang=js"
export * from "./MoonLandingPageFooter.vue?vue&type=script&lang=js"
import style0 from "./MoonLandingPageFooter.vue?vue&type=style&index=0&id=7fdb8f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb8f75",
  null
  
)

export default component.exports